import QTimeSelect from '../date-picker/src/picker/time-select';


export default QTimeSelect;
